module.exports = __webpack_public_path__ + "static/media/man-happy.08d9fdef.png";